/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Factual_Sweet_Swallow_LaughInputs */

const en_factual_sweet_swallow_laugh = /** @type {(inputs: Factual_Sweet_Swallow_LaughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labels`)
};

const de_factual_sweet_swallow_laugh = /** @type {(inputs: Factual_Sweet_Swallow_LaughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labels`)
};

/**
* | output |
* | --- |
* | "Labels" |
*
* @param {Factual_Sweet_Swallow_LaughInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const factual_sweet_swallow_laugh = /** @type {((inputs?: Factual_Sweet_Swallow_LaughInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Factual_Sweet_Swallow_LaughInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_factual_sweet_swallow_laugh(inputs)
	return de_factual_sweet_swallow_laugh(inputs)
});